/**
 * useOccupationEntryScreen.js
 * ----------------------
 * Hook for Occupation create/edit form screen using shared useMasterEntry.
 */
import { useMasterEntry } from '../../common/useMasterEntry';
import * as occupationApi from '../api/occupationApi';

export function useOccupationEntryScreen() {
  return useMasterEntry({
    entityName: 'Occupation',
    apiClient: occupationApi.occupationClient,
    fetchDetail: occupationApi.getOccupationDetail,
    createItem: occupationApi.createOccupation,
    updateItem: occupationApi.updateOccupation,
    initialForm: {
      name: '',
      code: '',
    },
    validate: (form) => {
      if (!form.name || !form.name.trim()) {
        return 'Occupation Name is required.';
      }
      return null;
    },
    listPath: '/masters/occupation/list',
  });
}
